class DiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.open = false;
  }

  init(){

    //Check Cookies
    if ( document.cookie.search('discount_popup') !== -1) {
      //not first visit
    } else {
        //first visit
        this.open = true;
        this.classList.add('open');

        //set cookie to avoid showing the modal again
        const expires = new Date();
        expires.setDate(expires.getDate() + 7); // Expira em 7 dias
        document.cookie = `discount_popup=True; expires=${expires.toUTCString()}; path=/;`;

        this.events();

    }
  }

  events(){

    //Close button
    this.querySelector('.button-close').addEventListener('click', () => {
      this.open = false;
      this.classList.remove('open');
      document.dispatchEvent(new Event('modal-close'));
    });

    //Close background
    this.addEventListener('click', (event) => {
        if(event.target === this){
            this.open = false;
            this.classList.remove('open');
            document.dispatchEvent(new Event('modal-close'));
        }
    })
  }

  
}

  customElements.define('discount-modal', DiscountPopup);
  
  const modalDiscEl = document.getElementsByTagName('discount-modal');
  console.log('modalDiscEl', modalDiscEl)

  if (modalDiscEl.length > 0) {
      modalDiscEl[0].addEventListener('open', (m) => {
        modalDiscEl[0].init();
      });
  }